import { ColDef } from 'ag-grid-community';
import { PartnerSearchByBrResponse, PrivateBankingServiceDefinitionId } from 'pco-product-service-internal-consumer';
import { ebankingPartnerSearchColumns } from '../../components/ebankingPartnerSearchColumns';

type PartnerServiceRoleProductId =
  | typeof PrivateBankingServiceDefinitionId.Ebanking
  | typeof PrivateBankingServiceDefinitionId.DebitMaestrocard;

export type PartnerServiceRoleProductConfig = {
  allowAllPartnersSearch: boolean;
  linksContactNotes: boolean;
  extraPartnerSearchColumns: ColDef<PartnerSearchByBrResponse>[];
};

export const partnerServiceRoleProductConfigs = {
  [PrivateBankingServiceDefinitionId.Ebanking]: {
    allowAllPartnersSearch: false,
    linksContactNotes: false,
    extraPartnerSearchColumns: ebankingPartnerSearchColumns,
  },
  [PrivateBankingServiceDefinitionId.DebitMaestrocard]: {
    allowAllPartnersSearch: true,
    linksContactNotes: true,
    extraPartnerSearchColumns: [],
  },
} satisfies Record<PartnerServiceRoleProductId, PartnerServiceRoleProductConfig>;

export const getPartnerServiceRoleProductConfig = (
  serviceDefinitionId: PrivateBankingServiceDefinitionId | undefined,
): PartnerServiceRoleProductConfig => {
  const config = partnerServiceRoleProductConfigs[serviceDefinitionId as PartnerServiceRoleProductId];
  if (!config) {
    throw new Error(`No partner service role configuration for ${serviceDefinitionId}`);
  }
  return config;
};
